/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};
app.countryFlags = {
  'russia': {code: '+7', nameEn: 'russia', nameRu: 'Россия', countryId: 643},
  'kazakhstan': {code: '+7', nameEn: 'kazakhstan', nameRu: 'Казахстан', countryId: 398},
  'armenia': {code: '+374', nameEn: 'armenia', nameRu: 'Армения', countryId: 51},
  'belarus': {code: '+375', nameEn: 'belarus', nameRu: 'Беларусь', countryId: 112},
  'kyrgyzstan': {code: '+996', nameEn: 'kyrgyzstan', nameRu: 'Кыргызстан', countryId: 417},
  'azerbaijan': {code: '+994', nameEn: 'azerbaijan', nameRu: 'Азербайджан', countryId: 31},
  'georgia': {code: '+995', nameEn: 'georgia', nameRu: 'Грузия', countryId: 268},
  'moldova': {code: '+373', nameEn: 'moldova', nameRu: 'Молдова', countryId: 498},
  'tajikistan': {code: '+992', nameEn: 'tajikistan', nameRu: 'Таджикистан', countryId: 762},
  'turkmenistan': {code: '+993', nameEn: 'turkmenistan', nameRu: 'Туркмения', countryId: 795},
  'uzbekistan': {code: '+998', nameEn: 'uzbekistan', nameRu: 'Узбекистан', countryId: 860},
  'ukraine': {code: '+380', nameEn: 'ukraine', nameRu: 'Украина', countryId: 804},
  'other': {code: ' ', nameEn: 'other', nameRu: 'Другое', countryId: -1}
};

}.call(window));